(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["age-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const gate = document.querySelector('[data-yoria-age-gate]');
    if (!gate) return;
    const verifiedKey = 'yoria_age_ok_v3';
    const dialog = gate.querySelector('[data-age-dialog]');
    const gateStage = gate.querySelector('[data-age-stage="gate"]');
    const deniedStage = gate.querySelector('[data-age-stage="denied"]');
    const confirm = gate.querySelector('[data-age-confirm]');
    const deny = gate.querySelector('[data-age-deny]');
    const returnButton = gate.querySelector('[data-age-return]');
    const errorMessage = gate.querySelector('[data-age-error]');
    const checkoutSelector = '[data-age-checkout], .shopify-payment-button, shopify-accelerated-checkout';
    let pendingAction = null;
    let previousFocus = null;
    let previousOverflow = '';
    let inertSiblings = [];
    let bypassOnce = false;
    let verifiedInMemory = false;

    const isVerified = () => {
      if (verifiedInMemory) return true;
      try {
        return sessionStorage.getItem(verifiedKey) === 'true';
      } catch (_) {
        return false;
      }
    };

    const markVerified = () => {
      verifiedInMemory = true;
      try {
        sessionStorage.setItem(verifiedKey, 'true');
      } catch (_) {
      }
    };

    const persistVerification = async () => {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            '年齢確認': '18歳以上確認済み'
          }
        })
      });
      if (!response.ok) throw new Error('Unable to save age verification');
      return response.json();
    };

    const focusable = () => Array.from(gate.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'))
      .filter((element) => !element.closest('[hidden]'));

    const setBackgroundInert = (inert) => {
      if (inert) {
        inertSiblings = Array.from(document.body.children).filter((element) => element !== gate && !element.hasAttribute('inert'));
        inertSiblings.forEach((element) => element.setAttribute('inert', ''));
        return;
      }
      inertSiblings.forEach((element) => element.removeAttribute('inert'));
      inertSiblings = [];
    };

    const resetStage = () => {
      gateStage.hidden = false;
      deniedStage.hidden = true;
      errorMessage.hidden = true;
      confirm.disabled = false;
      deny.disabled = false;
      dialog?.setAttribute('aria-labelledby', 'YoriaAgeGateTitle');
      dialog?.setAttribute('aria-describedby', 'YoriaAgeGateText');
    };

    const closeGate = ({ restoreFocus = true } = {}) => {
      gate.hidden = true;
      document.body.style.overflow = previousOverflow;
      setBackgroundInert(false);
      if (restoreFocus && previousFocus instanceof HTMLElement) previousFocus.focus();
      previousFocus = null;
      resetStage();
    };

    const openGate = (action, source) => {
      pendingAction = action;
      previousFocus = source instanceof HTMLElement ? source : document.activeElement;
      previousOverflow = document.body.style.overflow;
      resetStage();
      gate.hidden = false;
      document.body.style.overflow = 'hidden';
      setBackgroundInert(true);
      requestAnimationFrame(() => confirm?.focus());
    };

    const replayPendingAction = () => {
      const action = pendingAction;
      pendingAction = null;
      if (!action) return;
      bypassOnce = true;
      action();
      setTimeout(() => { bypassOnce = false; }, 0);
    };

    const persistAndReplay = async (action, source) => {
      try {
        await persistVerification();
        bypassOnce = true;
        action();
        setTimeout(() => { bypassOnce = false; }, 0);
      } catch (_) {
        openGate(action, source);
        errorMessage.hidden = false;
      }
    };

    const checkoutTriggerFromEvent = (event) => {
      const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
      const trigger = path.find((node) => node instanceof Element && node.matches?.(checkoutSelector));
      if (!trigger) return null;
      const replayTarget = path.find((node) => node instanceof HTMLElement && node !== gate && typeof node.click === 'function');
      return { trigger, replayTarget: replayTarget || trigger };
    };

    document.addEventListener('click', (event) => {
      const match = checkoutTriggerFromEvent(event);
      if (!match || bypassOnce) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (isVerified()) {
        persistAndReplay(() => match.replayTarget.click(), match.replayTarget);
        return;
      }
      openGate(() => match.replayTarget.click(), match.replayTarget);
    }, true);

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter;
      if (!(submitter instanceof HTMLElement) || !submitter.matches('[data-age-checkout]') || bypassOnce) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (isVerified()) {
        persistAndReplay(() => event.target.requestSubmit(submitter), submitter);
        return;
      }
      openGate(() => event.target.requestSubmit(submitter), submitter);
    }, true);

    confirm?.addEventListener('click', async () => {
      confirm.disabled = true;
      deny.disabled = true;
      errorMessage.hidden = true;
      try {
        await persistVerification();
        markVerified();
        closeGate({ restoreFocus: false });
        replayPendingAction();
      } catch (_) {
        confirm.disabled = false;
        deny.disabled = false;
        errorMessage.hidden = false;
      }
    });
    deny?.addEventListener('click', () => {
      gateStage.hidden = true;
      deniedStage.hidden = false;
      dialog?.setAttribute('aria-labelledby', 'YoriaAgeGateDeniedTitle');
      dialog?.setAttribute('aria-describedby', 'YoriaAgeGateDeniedText');
      returnButton?.focus();
    });
    returnButton?.addEventListener('click', () => {
      pendingAction = null;
      closeGate();
    });
    gate.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        pendingAction = null;
        closeGate();
        return;
      }
      if (event.key !== 'Tab') return;
      const elements = focusable();
      if (!elements.length) {
        event.preventDefault();
        dialog?.focus();
        return;
      }
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
